let slideIndex = 0;
let chosenModelNumber = 1;
function showSlides(n) {
    let slides = document.querySelectorAll(".slide:not(.hidden-slide-image)");
    // let dots = document.querySelectorAll(".dot");

    if (n >= slides.length) slideIndex = 0;
    if (n < 0) slideIndex = slides.length - 1;

    slides.forEach(slide => slide.style.display = "none");
    // dots.forEach(dot => dot.classList.remove("active"));

    slides[slideIndex].style.display = "block";
    // dots[slideIndex].classList.add("active");
}

function changeSlide(n) {
    slideIndex += n;
    showSlides(slideIndex);
}

function currentSlide(n) {
    slideIndex = n - 1;
    showSlides(slideIndex);
}

function autoSlide() {
    slideIndex++;
    showSlides(slideIndex);
    setTimeout(autoSlide, 3000);
}

document.addEventListener("DOMContentLoaded", () => {
    showSlides(slideIndex);
    //setTimeout(autoSlide, 3000);
});

(function() {
let slideShow;
window.onload = () => {

    const modelNameDivs = document.querySelectorAll("[data-model-name]");

    if (modelNameDivs) {
        modelNameDivs.forEach(div => {
            div.addEventListener('click', (event) => {
                // Reset style for names
                modelNameDivs.forEach(div => {
                    div.style.fontWeight = 'normal';
                    div.style.cursor = "pointer"
                    div.classList.remove('active-model-name')
                })

                chosenModelNumber = event.target.dataset.modelNumber;

                let chosenColor = document.querySelector('input[name="globo-option-0"]:checked').value;

                slideShow = document.getElementById('slideshow-mobile-container');

                // Set new styles to model names
                div.style.fontWeight = 'bold';
                div.style.cursor = "auto"
                div.classList.add('active-model-name')

                clearAttributesOnDesktop();
                displayAssociatedImagesOnDesktop(event, chosenColor);
                clearAttributesOnMobile();
                displayAssociatedImagesOnMobile(event, chosenColor);

                displayCorrespondingModelInformation(chosenModelNumber)
            })
        })
    }

    let radioButtons = document.querySelectorAll('input[name="globo-option-0"]');

    radioButtons.forEach(radio => {
        radio.addEventListener("click", (event) => {
            Array.from(document.querySelectorAll("[data-swatch-color-value]"))
                .filter(e => {
                    e.classList.remove('golden-ring')
                    return e.dataset.swatchColorValue.toLowerCase().trim() == event.target.value.toLowerCase().trim()
                })
                .forEach(e => e.classList.add('golden-ring'))

                setTimeout(() => {
                    let element = document.querySelector(".active-model-name");
                    element && element.click();
                },10)
        });
    });

    const upperSwatchColors = document.querySelectorAll("[data-swatch-color-value]");

    upperSwatchColors.forEach(e => {
        e.addEventListener('click', (event) => {
            upperSwatchColors.forEach(el => el.classList.remove('golden-ring'));
            const target = event.target;
            target.classList.add('golden-ring')

            let radioButtons = document.querySelectorAll('input[name="globo-option-0"]');
            const radioItem = Array.from(radioButtons).filter(el => el.value.toLowerCase().trim() === target.dataset.swatchColorValue.toLowerCase().trim())
            radioItem.at(0) && radioItem.at(0).click();

            setTimeout(() => {
                let element = document.querySelector(".active-model-name");
                element && element.click();
            },10)
        })
    })

};

function clearAttributesOnDesktop() {
    document.querySelectorAll(".bra-model-image-container")
        .forEach(el => el.style.display = 'none');
}

function clearAttributesOnMobile() {
    document.querySelectorAll(".bra-images-slide")
        .forEach(el => {
            el.style.display = 'none';
            el.classList.add('hidden-slide-image')
        });
}

function displayAssociatedImagesOnDesktop(event, chosenColor) {
    const eventTarget = event.target;

    chosenColor = chosenColor.trim().toLowerCase();

    let modelNumber = eventTarget.dataset.modelNumber;
    let tagColor = 'merlot';

    if (chosenColor && chosenColor.trim()) {
        if (chosenColor.includes('black')) {
            tagColor = 'black';
        }
        else if (chosenColor.includes('creme')) {
            tagColor = 'creme'
        }
        else if (chosenColor.includes('pink')) {
            tagColor = 'pink'
        }
    }

    const modelNumberName = `model_${modelNumber}_name`;
    let targetElementId = `${modelNumberName}-model-tabpanel-${tagColor}`;

    let targetElement = document.getElementById(targetElementId);
    let images;

    if (targetElement) {
        images = targetElement.getElementsByTagName('img')
    }

    // Use default if target element is null
    if (!targetElement || !images.length) {
        tagColor = 'merlot'
        targetElementId = `${modelNumberName}-model-tabpanel-${tagColor}`;
        targetElement = document.getElementById(targetElementId);
    }

    targetElement.style.display = 'grid'
}

function displayAssociatedImagesOnMobile(event, chosenColor) {
    const eventTarget = event.target;

    chosenColor = chosenColor.trim().toLowerCase();

    let modelNumber = eventTarget.dataset.modelNumber;
    let tagColor = 'merlot';

    if (chosenColor && chosenColor.trim()) {
        if (chosenColor.includes('black')) {
            tagColor = 'black';
        }
        else if (chosenColor.includes('creme')) {
            tagColor = 'creme'
        }
        else if (chosenColor.includes('pink')) {
            tagColor = 'pink'
        }
    }

    const modelNumberName = `model_${modelNumber}_name`;
    let targetElementsClassName = `.${modelNumberName}-slide-image-${tagColor}`;

    let targetElements = document.querySelectorAll(targetElementsClassName);
    let images = [];

    if (targetElements && targetElements.length) {
        targetElements.forEach(el => {
            if (images.length) return;
            const img = el.getElementsByTagName('img');
            images.push(img);
        })
    }

    // Use default if target element is null
    if (!targetElements || !images.length) {
        tagColor = 'merlot'
        targetElementsClassName = `.${modelNumberName}-slide-image-${tagColor}`;
        targetElements = document.querySelectorAll(targetElementsClassName);
    }

    if (targetElements) {
        targetElements.forEach(el => {
            el.style.display = 'block';
            el.classList.remove('hidden-slide-image')
        });

        if (slideShow && slideShow.style.display != 'none') {
            slideIndex = 0;
            showSlides(slideIndex);
        }
    }
}
})();

function nameSlider() {
    const slider = document.getElementById("custom-slider");
    const leftButton = document.querySelector("[data-left-tab]");
    const rightButton = document.querySelector("[data-right-tab]");

    leftButton.addEventListener("click", function() {
      slider.classList.remove("right-selected");
      slider.classList.add("left-selected");
    });

    rightButton.addEventListener("click", function() {
      slider.classList.remove("left-selected");
      slider.classList.add("right-selected");
    });
}

function displayCorrespondingModelInformation(modelNumber) {
    document.querySelectorAll('.model-information-details')
    .forEach(e => e.style.display = 'none')

    document.getElementById('model-information-' + modelNumber)
    .style.display = 'block';
}